import Vue from 'vue';
export default Vue.component('ed-link', {
  name: 'ed-link',
  props: ['href', 'target', 'isNotActive', 'title', 'isDisabled'],
  computed: {
    _href() {
      return this.href ? this.href : '';
    },
    _target() {
      return this.target ? this.target : '';
    },
    _title() {
      return this.title ? this.title : ''
    },
    classes() {
      return {
        'ed-link--not-active': this.isNotActive,
        'ed-link--active': !this.isNotActive,
        'opacity-50': this.isDisabled
      };
    }
  }
});